function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "ICONS/FIGURES/ico-30-vitrine");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeDasharray: "6,2"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/FIGURES/ico-30-vitrine",
  stroke: "#000000",
  strokeWidth: 6
}, /*#__PURE__*/React.createElement("line", {
  x1: 4,
  y1: 15,
  x2: 26,
  y2: 15,
  id: "Line-4"
})));

const SvgIco30Vitrine = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30px",
  height: "30px",
  viewBox: "0 0 30 30",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIco30Vitrine, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ico-30-vitrine.25cd9927.svg";
export { ForwardRef as ReactComponent };